<template>
  <router-view />
</template>

<style scoped>
*,
:after,
:before {
  box-sizing: border-box;
}
body {
  padding: 0;
  margin: 0;
}
</style>
